import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { type AuthUserOutputDataOrganisationHeadcount, organisationHeadcount } from '@jobilla/nexus-sdk'
import { useTranslation } from 'react-i18next'
import { ScreenHeading } from './screen-heading'

const OPTIONS = Object.values(organisationHeadcount)

type Props = {
	current: AuthUserOutputDataOrganisationHeadcount | null
	onSubmit: (value: AuthUserOutputDataOrganisationHeadcount) => void
	isSubmitting: boolean
}

export function OrganisationHeadcountScreen({ current, onSubmit, isSubmitting }: Props) {
	const { t } = useTranslation()

	return (
		<>
			<ScreenHeading
				title={t('onboarding.organisationHeadcount.title')}
				subtitle={t('onboarding.organisationHeadcount.subtitle')}
			/>
			<div className="grid grid-cols-2 gap-3">
				{OPTIONS.map(headcount => (
					<Button
						key={headcount}
						variant={current === headcount ? 'default' : 'outline'}
						disabled={isSubmitting}
						onClick={() => onSubmit(headcount)}
						className={cn(
							'h-14',
							current === headcount && 'bg-brand-600 hover:bg-brand-700 text-white border-brand-600',
						)}
					>
						{headcount}
					</Button>
				))}
			</div>
		</>
	)
}
